const cachios = require('cachios');
const axios = require('axios');

// Only the real production hostname reaches the production API; localhost uses
// the bare dev server, and anything else (.lan addresses) fails safe to the
// Caddy-proxied dev API — never production.
const apiUrl = (location.hostname === 'app.my247ed.com') ? 'https://api.my247ed.com/'
    : (location.hostname === 'localhost') ? 'http://localhost:3000/'
    : 'https://api.my247ed.lan/';
const axiosInstance = axios.create({
    baseURL:  apiUrl
});

import axiosRetry from 'axios-retry';

axiosRetry(axiosInstance, {
    retries: 10,
    retryDelay: axiosRetry.exponentialDelay
});

// all requests will now use this axios instance
const client = cachios.create(axiosInstance, {
    stdTTL: 120
});

const stripePK = (location.hostname === 'app.my247ed.com') ? 'pk_live_Ylvt97HVw0adW0ilmHdioiT600COyL1MJh' : 'pk_test_Mx213mFpG7pCFQ9szH6NQ9ER00rERfI0s8';

// Call immediately before stripe.confirmCardPayment: the charge only needs the
// intent's client_secret (no session), but fulfillment afterward needs a live JWT.
// A stale tab can otherwise charge the card and then 401 on the fulfillment call.
// Uses axiosInstance directly so the cachios cache can't mask an expired session.
function verifySession() {
    return axiosInstance.get('app/users/me');
}

export {client, axiosInstance, apiUrl, stripePK, verifySession};
